import { Grid, InputAdornment } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { CustomAttributesSection } from "components/CustomAttributesSection/CustomAttributesSection";
import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { TextInput } from "components/FormControls/TextInput";
import { useMessage } from "hooks/intl";
import { selectCurrentStoreData } from "reduxState/currentStoreData/currentStoreDataSlice";
import { KeyValuePair } from "utilities/objects";

export type ProductType = {
  category?: string;
  grossValue?: string;
  labels?: KeyValuePair[];
  maker?: string;
  name?: string;
  qty?: string;
  sku?: string;
};

interface Props {
  index: number;
  details: ProductType;
}

export const Product = ({ index, details }: Props) => {
  const { message } = useMessage();
  const { currency: currentStoreCurrency } = useAppSelector(
    selectCurrentStoreData,
  );

  return (
    <Grid container spacing={12}>
      <Grid item xs={6}>
        <TextInput
          label={message({ id: "productName" })}
          name={`transaction.items[${index}].name`}
          width="100%"
          data-test-id={`product-${index}-name`}
        />
      </Grid>
      <Grid item xs={6}>
        <TextInput
          label={message({ id: "productSKU" })}
          name={`transaction.items[${index}].sku`}
          width="100%"
          data-test-id={`product-${index}-sku`}
        />
      </Grid>
      <Grid item xs={6}>
        <NumberFormatInput
          allowDecimals
          label={message({ id: "grossValue" })}
          name={`transaction.items[${index}].grossValue`}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {currentStoreCurrency}
              </InputAdornment>
            ),
          }}
          data-test-id={`product-${index}-grossValue`}
        />
      </Grid>
      <Grid item xs={6}>
        <NumberFormatInput
          allowDecimals
          decimalScale={3}
          label={message({ id: "productQuantity" })}
          name={`transaction.items[${index}].highPrecisionQuantity`}
          data-test-id={`product-${index}-qty`}
        />
      </Grid>
      <Grid item xs={6}>
        <TextInput
          label={message({ id: "brandName" })}
          name={`transaction.items[${index}].maker`}
          width="100%"
          data-test-id={`product-${index}-brand`}
        />
      </Grid>
      <Grid item xs={6}>
        <TextInput
          label={message({ id: "category" })}
          name={`transaction.items[${index}].category`}
          width="100%"
          data-test-id={`product-${index}-category`}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomAttributesSection
          labels={details.labels || []}
          name={`transaction.items[${index}]`}
        />
      </Grid>
    </Grid>
  );
};
